(function () {
  if (window.__sizeGuideJSLoaded) return;
  window.__sizeGuideJSLoaded = true;

  function convertToCm(text) {
    return text.replace(/(\d+(?:\.\d+)?)/g, function (match) {
      var inches = parseFloat(match);
      if (isNaN(inches)) return match;
      var cm = inches * 2.54;
      return (Math.round(cm * 10) / 10).toString();
    });
  }

  function initInstance(root) {
    if (!root || root.__sizeGuideInit) return;
    root.__sizeGuideInit = true;

    var tabs = root.querySelectorAll('[data-size-guide-tab]');
    var panels = root.querySelectorAll('[data-size-guide-panel]');
    var unitWrap = root.querySelector('[data-size-guide-unit-wrap]');
    var unitToggle = root.querySelector('[data-size-guide-unit-toggle]');
    var unitLabels = root.querySelectorAll('[data-size-guide-unit-text]');
    var closeBtn = root.querySelector('[data-size-guide-close]');

    function activateTab(name) {
      tabs.forEach(function (t) {
        var active = t.getAttribute('data-size-guide-tab') === name;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      var activePanel = null;
      panels.forEach(function (p) {
        var active = p.getAttribute('data-size-guide-panel') === name;
        p.classList.toggle('is-active', active);
        if (active) {
          p.removeAttribute('hidden');
          activePanel = p;
        } else {
          p.setAttribute('hidden', '');
        }
      });
      if (unitWrap) {
        var hasTable = activePanel && activePanel.querySelector('.size-guide__table');
        unitWrap.style.display = hasTable ? '' : 'none';
      }
    }

    function setUnit(unit) {
      var isCm = unit === 'cm';
      if (unitToggle) {
        unitToggle.classList.toggle('is-cm', isCm);
        unitToggle.setAttribute('aria-checked', isCm ? 'true' : 'false');
      }
      unitLabels.forEach(function (label) {
        label.classList.toggle('is-active', label.getAttribute('data-size-guide-unit-text') === unit);
      });
      root.querySelectorAll('[data-size-guide-col]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-size-guide-col') === unit);
      });
      root.querySelectorAll('[data-size-guide-cell]').forEach(function (cell) {
        var original = cell.getAttribute('data-original');
        if (original === null) {
          original = cell.textContent.trim();
          cell.setAttribute('data-original', original);
        }
        cell.textContent = isCm ? convertToCm(original) : original;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.getAttribute('data-size-guide-tab'));
      });
    });

    if (unitToggle) {
      unitToggle.addEventListener('click', function () {
        setUnit(unitToggle.classList.contains('is-cm') ? 'in' : 'cm');
      });
    }
    unitLabels.forEach(function (label) {
      label.addEventListener('click', function () {
        setUnit(label.getAttribute('data-size-guide-unit-text'));
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        var popupBody = root.closest('[data-js-popup-name]') || root.closest('.popup');
        if (popupBody) {
          var trigger = popupBody.querySelector('[data-js-popup-close]');
          if (trigger) { trigger.click(); return; }
        }
        root.dispatchEvent(new CustomEvent('size-guide:close', { bubbles: true }));
      });
    }

    var slider = root.querySelector('[data-size-guide-slider]');
    if (slider) {
      var slides = slider.querySelectorAll('[data-size-guide-slide]');
      var prevBtn = slider.querySelector('[data-size-guide-prev]');
      var nextBtn = slider.querySelector('[data-size-guide-next]');
      var current = 0;

      function updateArrows() {
        if (prevBtn) prevBtn.classList.toggle('is-hidden', current === 0);
        if (nextBtn) nextBtn.classList.toggle('is-hidden', current === slides.length - 1);
      }

      function goTo(index) {
        if (!slides.length) return;
        current = Math.max(0, Math.min(slides.length - 1, index));
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === current);
        });
        updateArrows();
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
      updateArrows();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-size-guide]').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  window.SizeGuide = { init: initAll };
})();
